import { Confidence } from "@memorang/types";
import { Button, Container } from "@memorang/ui";
import * as Animatable from "react-native-animatable";

type Props = {
	onConfidenceProvided: (confidence: Confidence) => void;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
};

const ConfidenceSubmitButtons = ({
	onConfidenceProvided,
	handleTrackConfidenceClick,
}: Props) => {
	const handleSubmit = () => {
		handleTrackConfidenceClick(Confidence.high);
		onConfidenceProvided(Confidence.high);
	};

	return (
		<Container maxWidth="xs">
			<Animatable.View
				useNativeDriver
				duration={300}
				animation="fadeIn"
				easing="ease-out"
			>
				<Button mode="contained" onPress={handleSubmit}>
					Submit
				</Button>
			</Animatable.View>
		</Container>
	);
};

export default ConfidenceSubmitButtons;
